import { render } from "./main.vue?vue&type=template&id=3cc92a02&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=3cc92a02&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mr.Wu\\Desktop\\Files\\XiHe\\code\\xihe_levelexam_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc92a02"]])

export default __exports__